import { DomFlightSortingTypes } from "@website/ticket-ui/common/types";

export const CHANNEL_LOOKUP_TABLE = {
  myirancell: "myirancell",
  snappjek_native: "JEK_NATIVE",
  SNAPPTRIP_APP: "SNAPPTRIP_APP",
  ANONYMOUS: "ANONYMOUS",
  WEB_APP: "WEB_APP",
  AD: "AD"
} as const;

export type Channels = keyof typeof CHANNEL_LOOKUP_TABLE;

export const DOM_FLIGHT_ORDER_BY_WEBENGAGE_OPTIONS: Record<
  DomFlightSortingTypes,
  string
> = {
  lowest_price: "cheapest",
  highest_price: "most_expensive",
  lowest_flight_duration: "least_journey_duration",
  earliest: "earliest",
  latest: "latest",
  recommended: "recommended"
};
